module.exports = __webpack_public_path__ + "static/media/calendarW.0eb60c3e.svg";